import {Component, OnInit, ViewChild} from "@angular/core";
import {throwError } from 'rxjs';
import {RegisterService} from "./register.service";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'reject',
    templateUrl: 'reject.component.html',
    providers: [RegisterService]
})

export class RejectComponent implements OnInit {

    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    public showChildModal(): void {this.msgModal.show();}
    public hideChildModal(): void {this.msgModal.hide();}

    protected redirectTitle = "";
    private token: String;
    private loading: boolean = false;
    private hasError : boolean;
    constructor(private registerService: RegisterService, protected route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.token = params.token;
            this.validateToken()},
            error => {
               return throwError(error);
            }
        );
    }

    validateToken(){
        this.loading = true;
        this.registerService.rejectBySupplier(this.token).subscribe(
            data => {
                if(data.success){
                    this.hasError = false
                    this.loading = false;
                    this.redirectTitle = 'Invitation successfully rejected';
                    this.showChildModal();   
                }
                else{
                    this.loading = false;
                    this.hasError = true
                    this.redirectTitle = 'Something went wrong.Please try again!';
                    this.showChildModal();  
                }
            },
            error => {
                this.loading = false;   
            }
        );
    }
}